import { Box, Chip, Typography } from '@mui/material';
import type { TFunction } from 'i18next';
import TableActions from '../../../components/TableActions';
import type { Column } from '../../../core-components/theme/components/Table/Table';
import { Primary } from '../../../core-components/theme/color-palette/colors';
import type { RowActionAccess, RowModalProps } from '../../../components/TableActions';
import AddLogbookTemplateModal from '../components/AddLogbookTemplateModal';
import DeleteLogbookModal from '../components/DeleteLogbook';
import { LogbookTemplate } from '../types/loogBookTypes';

const EditLogbookTemplate = ({ data, handleClose }: RowModalProps<LogbookTemplate>) => (
  <AddLogbookTemplateModal open initialData={data} onClose={handleClose} />
);

export const columns = (
  t: TFunction,
  rowAccess: RowActionAccess,
  onEditIntent: (row: LogbookTemplate) => void,
): Column<LogbookTemplate>[] => [
    {
      field: 'name',
      headerName: t('logbook.templates.columns.logbookDetails', 'Logbook Details'),
      align: 'left' as const,
      width: '60%',
      renderCell: (value: string, row: LogbookTemplate) => (
        <Box>
          <Typography variant="body1" fontWeight="bold" sx={{ marginBottom: '2px' }}>
            {row.name || t('logbook.templates.columns.noName', 'No Name')}
          </Typography>
          <Typography variant="body2" >
            {row.description}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'type',
      headerName: t('logbook.templates.form.type', 'Type'),
      align: 'center',
      renderCell: (value: string, row: LogbookTemplate) => {
        return (
          <Chip
            label={value}
            sx={{
              color: 'primary.main',
              border: `1px solid ${Primary[200]}`,
              background: 'none',
            }}
          />
        );
      },
    },
    {
      field: 'action',
      headerName: t('common.action', 'Action'),
      align: 'right',
      getActions: (row: LogbookTemplate) => {
        return (
          <TableActions
            rowData={row}
            canEdit={rowAccess.canEdit}
            canDelete={rowAccess.canDelete}
            EditComponent={EditLogbookTemplate}
            DeleteComponent={DeleteLogbookModal}
            onEditIntent={onEditIntent}
          />
        );
      },
    },
  ];